import React from 'react';
import { SimpleTableRowProps } from './simple-table-row.props';
import { Divider } from 'common/common-components.styled';
import { SimpleTableColumnTypes } from 'components/simple-table/simple-table.props';
import TextCell from 'components/simple-table/text-cell';
import LinkCell from 'components/simple-table/link-cell';
import ArrowCell from 'components/simple-table/arrow-cell';
import { StyledEditIcon, StyledSimpleTableRow } from '../simple-table.styled';
import { PenIcon } from 'components/icons-new/pen';
import MenuCell from 'components/simple-table/menu-cell';
import CustomCell from '../custom-cell';

const SimpleTableRow = <TRow,>({ row, columns, editRowConfig }: SimpleTableRowProps<TRow>) => {
  return (
    <div>
      <StyledSimpleTableRow>
        {columns.map(column => {
          switch (column.type) {
            case SimpleTableColumnTypes.Text:
              return <TextCell key={column.title} column={column} row={row} />;
            case SimpleTableColumnTypes.Link:
              return <LinkCell key={column.title} column={column} row={row} />;
            case SimpleTableColumnTypes.Arrow:
              return <ArrowCell key={column.title} column={column} row={row} />;
            case SimpleTableColumnTypes.Menu:
              return <MenuCell key={column.title} column={column} row={row} />;
            case SimpleTableColumnTypes.Custom:
              return <CustomCell key={column.title} column={column} row={row} />;
            default:
              return null;
          }
        })}
        {editRowConfig && editRowConfig.isRowEditable(row) && (
          <StyledEditIcon onClick={() => editRowConfig.editHandler(row)}>
            <PenIcon hovered />
          </StyledEditIcon>
        )}
      </StyledSimpleTableRow>
      <Divider color='grey100' />
    </div>
  );
};

export default SimpleTableRow;
